import React from 'react'

import {
  CalendarCard,
  CalendarHeader,
  NavButtonsGroup,
  NavButton,
  WeekdaysRow,
  WeekdayCell,
  CalendarGrid,
  DayCell,
} from './BookingsPortalPage.styled'

import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'

type CalendarPanelProps = {
  dateTitle: string
  monthLabel: string
  weekdayShorts: string[]
  cells: {date: Date; outside: boolean}[]
  slotsByDate: Map<string, string[]>
  selectedDate: string | null
  onSelectDate: (dateKey: string) => void
  disablePrev?: boolean
  onPrevMonth: () => void
  onNextMonth: () => void
}

export const CalendarPanel: React.FC<CalendarPanelProps> = ({
  dateTitle,
  monthLabel,
  weekdayShorts,
  cells,
  slotsByDate,
  selectedDate,
  onSelectDate,
  disablePrev = false,
  onPrevMonth,
  onNextMonth,
}) => (
  <CalendarCard>
    <Typography weight="bold" size="lg">
      {dateTitle}
    </Typography>
    <CalendarHeader>
      <NavButtonsGroup>
        <NavButton onClick={onPrevMonth} disabled={disablePrev}>
          ‹
        </NavButton>
        <NavButton onClick={onNextMonth}>›</NavButton>
      </NavButtonsGroup>
      <Typography weight="bold">{monthLabel}</Typography>
    </CalendarHeader>

    <WeekdaysRow>
      {weekdayShorts.map((label, idx) => (
        <WeekdayCell key={`weekday-${idx}`}>
          <Typography size="sm">{label}</Typography>
        </WeekdayCell>
      ))}
    </WeekdaysRow>

    <CalendarGrid>
      {cells.map(({date, outside}) => {
        const yyyy = date.getFullYear()
        const mm = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        const dateKey = `${yyyy}/${mm}/${dd}`
        const slotCount = slotsByDate.get(dateKey)?.length || 0
        const isSelected = selectedDate === dateKey
        const isDisabled = slotCount === 0
        const classNames = [
          outside ? 'outside' : '',
          isSelected ? 'selected' : '',
          isDisabled ? 'disabled' : 'available',
        ]
          .filter(Boolean)
          .join(' ')
        return (
          <DayCell
            key={dateKey + String(outside)}
            className={classNames}
            onClick={() => onSelectDate(dateKey)}>
            <Container className="dateLabel">{date.getDate()}</Container>
          </DayCell>
        )
      })}
    </CalendarGrid>
  </CalendarCard>
)
